export default __webpack_public_path__ + "menu-home-icon.eaef587c873a7996313968cb1180f279.svg";